"use client";

import NextError from "next/error";
import posthog from "posthog-js";
import { useEffect } from "react";
import { isPostHogInitialized } from "@/components/posthog-provider";

export default function GlobalError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>) {
  useEffect(() => {
    if (isPostHogInitialized()) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
        <button type="button" onClick={reset}>
          Try again
        </button>
      </body>
    </html>
  );
}
